/**
 * @module components\ghInput\iconInput
 */
import Vue from "vue";
import Component from "vue-class-component";
import InputBase from "../inputBase";

@Component
export default class IconInput extends InputBase {}
